import { Directive, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { getAccountSubscription } from '@app/reducers/account/account-service.selectors';
import { hasReachedQuota } from '@app/shared/subscription-plan/subscription-quota.directive';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { SB_SPLIT_BUTTON, SplitButtonComponent } from '@sb/ui/split-button';
import { QuotaType } from '@shiftbase-com/ts-shared/models';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[splitButtonQuota]',
})
export class SplitButtonQuotaDirective implements OnInit, OnDestroy {
  private store = inject<Store<AppState>>(Store);
  private splitButton = inject<SplitButtonComponent>(SB_SPLIT_BUTTON);

  private accountSubscription: Subscription;

  @Input('splitButtonQuota')
  quota: QuotaType;

  ngOnInit() {
    this.accountSubscription = this.store.select(getAccountSubscription).subscribe((subscription) => {
      if (subscription && this.quota) {
        if (hasReachedQuota(this.quota, subscription)) {
          this.splitButton.disabled = true;
          this.splitButton.icon = 'lock';
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.accountSubscription) {
      this.accountSubscription.unsubscribe();
    }
  }
}
